import script from "./GroupPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupPicker.vue?vue&type=script&lang=ts&setup=true"

import "./GroupPicker.vue?vue&type=style&index=0&id=666e281f&lang=scss&scoped=true"

import exportComponent from "/data/devops/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666e281f"]])

export default __exports__